if (!customElements.get('wlsn-hearing-specialist-modal')) {
    class WLSNHearingSpecialistModal extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          open: 'is-open',
          bodyLockClass: 'body-lock',
          trigger: 'js-wlsn-hearing-specialist-modal-trigger',
          close: 'js-wlsn-hearing-specialist-modal-close',
          wrapper: 'js-wlsn-hearing-specialist-modal-wrapper'
        };

        this.elements = {
          wrapper: this.querySelector(`.${this.classes.wrapper}`),
          closeBtn: this.querySelector(`.${this.classes.close}`),
        }
  
        this.handleTriggerClick = this.handleTriggerClick.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
      }
  
      connectedCallback() {
        this.triggers = document.querySelectorAll(`.${this.classes.trigger}`);
  
        if (this.triggers.length > 0) {
          this.triggers.forEach(trigger => {
            trigger.addEventListener('click', this.handleTriggerClick);
          });
        }
  
        if (this.elements.closeBtn) {
          this.elements.closeBtn.addEventListener('click', this.handleCloseClick);
        }
  
        this.addEventListener('click', this.handleOutsideClick);
      }
  
      disconnectedCallback() {
        this.triggers.forEach(trigger => {
          trigger.removeEventListener('click', this.handleTriggerClick);
        });
  
        if (this.elements.closeBtn) {
          this.elements.closeBtn.removeEventListener('click', this.handleCloseClick);
        }
  
        this.removeEventListener('click', this.handleOutsideClick);
      }
  
      handleTriggerClick(event) {
        event.preventDefault();
        this.open();
      }
  
      handleCloseClick() {
        this.close();
      }
  
      handleOutsideClick(event) {
        if (!this.elements.wrapper.contains(event.target)) {
          this.close();
        }
      }
  
      open() {
        this.classList.add(this.classes.open);
        document.body.classList.add(this.classes.bodyLockClass);
      }
  
      close() {
        this.classList.remove(this.classes.open);
        document.body.classList.remove(this.classes.bodyLockClass);
      }
    }
  
    customElements.define('wlsn-hearing-specialist-modal', WLSNHearingSpecialistModal);
  }
  